import styled, { css } from 'styled-components';
import Typography from '@mui/material/Typography';
import { Colors } from '../../../theme';
import { breakpointLG, breakpointMD, breakpointSM } from '../styles/breakpoints';
import { body1, button } from '../styles/fonts';
export const BalanceContainer = styled('div')({
    width: '100%',
    padding: '8px 0 16px 0',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 64,
    height: 80,
    zIndex: 10,
    background: Colors.white,
    right: 0,
    margin: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 32,
    borderBottomRightRadius: 32,
    boxSizing: 'border-box',
    borderLeft: `1px solid ${Colors.cream100}`,
    borderRight: `1px solid ${Colors.cream100}`,
    borderBottom: `1px solid ${Colors.cream100}`,
    '> div:last-of-type': {
        margin: '8px 0 0',
    },
    [`@media (min-width: ${breakpointSM})`]: {
        top: 80,
    },
    [`@media (min-width: ${breakpointMD})`]: {
        width: 'max-content',
        flexDirection: 'row',
        padding: '8px 16px 24px 16px',
        margin: '0 0 0 auto',
        height: 56,
        '> div:last-of-type': {
            margin: '0 0 0 0',
        },
    },
    [`@media (min-width: ${breakpointLG})`]: {
        padding: '16px 16px 24px 16px',
        margin: '0 24px 0 auto',
        height: 64,
    },
});
export const BalanceItem = styled.div `
  display: flex;
  gap: 8px;
  padding: 0 16px;

  @media (min-width: ${breakpointMD}) {
    padding: 0 8px;
  }
`;
export const BalanceLabel = styled(Typography) `
  color: ${Colors.grey500};
  ${body1};
`;
export const negativeAmount = css `
  padding: 2px 4px;
  color: ${Colors.error100};
  background-color: ${Colors.error10};
`;
export const AmountLabel = styled.span `
  ${button};
  color: ${Colors.grey900};

  ${({ $isNegative }) => $isNegative && negativeAmount};
`;
//# sourceMappingURL=styles.js.map